<div class="flex gap-2 cola-4 mb-3">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>  
</div>

<p-tabView  [scrollable]="true"  (onChange)="onTabChange($event)"  >
    <p-tabPanel header="Documentos" >
        <p-table styleClass="mt-4" #grid [value]="templatesDocuments" [lazy]="true" (onLazyLoad)="loadDataDocument($event)" [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsDocuments" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                    <th width="100"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-template let-columns="columns">
                <tr (dblclick)="edit(template)">
                    <td>{{template.name}}</td>
                    <td>
                        <div class="flex gap-2 justify-content-end">
                            <p-button *ngIf="allowDelete" (click)="delete(template)" [rounded]="true" [text]="false"
                                severity="danger"><i class="pi pi-trash"></i></p-button>
                            <p-button *ngIf="allowWrite" (click)="edit(template)" [rounded]="true" [text]="false"><i
                                    class="pi pi-pencil"></i></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </p-tabPanel>
    <p-tabPanel header="Emails" >
        <p-table styleClass="mt-4" #grid [value]="templatesEmail" [lazy]="true" (onLazyLoad)="loadDataEmail($event)" [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsEmail" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                    <!--<th pSortableColumn="templateType">Tipo <p-sortIcon field="templateType"></p-sortIcon></th>-->
                    <th pSortableColumn="subject">Asunto <p-sortIcon field="subject"></p-sortIcon></th>
                    <th pSortableColumn="templateDestinationType">Dirigido para <p-sortIcon field="templateDestinationType"></p-sortIcon></th>
                    <th width="100"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-template let-columns="columns">
                <tr (dblclick)="edit(template)">
                    <td>{{template.name}}</td>
                    <!--<td>{{templatesService.getTemplateTypeLabel(template.templateType)}}</td>-->
                    <td>{{template.subject}}</td>
                    <td>{{ getTemplateDestinationLabel(template.templateDestinationType) }}</td>
                    <td>
                        <div class="flex gap-2 justify-content-end">
                            <p-button *ngIf="allowDelete" (click)="delete(template)" [rounded]="true" [text]="false"
                                severity="danger"><i class="pi pi-trash"></i></p-button>
                            <p-button *ngIf="allowWrite" (click)="edit(template)" [rounded]="true" [text]="false"><i
                                    class="pi pi-pencil"></i></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </p-tabPanel>
    <p-tabPanel header="SMS" >
        <p-table styleClass="mt-4" #grid [value]="templatesSMS" [lazy]="true" (onLazyLoad)="loadDataSMS($event)" [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsSMS" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                    <!--<th pSortableColumn="templateType">Tipo <p-sortIcon field="templateType"></p-sortIcon></th>-->
                    <th pSortableColumn="content">Contenido <p-sortIcon field="content"></p-sortIcon></th>
                    <th width="100"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-template let-columns="columns">
                <tr (dblclick)="edit(template)">
                    <td>{{template.name}}</td>
                    <!--<td>{{templatesService.getTemplateTypeLabel(template.templateType)}}</td>-->
                    <td [innerHTML]="template.content"></td>
                    <td>
                        <div class="flex gap-2 justify-content-end">
                            <p-button *ngIf="allowDelete" (click)="delete(template)" [rounded]="true" [text]="false"
                                severity="danger"><i class="pi pi-trash"></i></p-button>
                            <p-button *ngIf="allowWrite" (click)="edit(template)" [rounded]="true" [text]="false"><i
                                    class="pi pi-pencil"></i></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </p-tabPanel>
    <p-tabPanel header="Whatsapp" >
        <p-table styleClass="mt-4" #grid [value]="templatesWhatsapp" [lazy]="true" (onLazyLoad)="loadDataWhatsapp($event)" [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsWhatsapp" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                    <!--<th pSortableColumn="templateType">Tipo <p-sortIcon field="templateType"></p-sortIcon></th>-->
                    <th pSortableColumn="subject">Asunto <p-sortIcon field="subject"></p-sortIcon></th>
                    <th width="100"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-template let-columns="columns">
                <tr (dblclick)="edit(template)">
                    <td>{{template.name}}</td>
                    <!--<td>{{templatesService.getTemplateTypeLabel(template.templateType)}}</td>-->
                    <td>{{template.subject}}</td>
                    <td>
                        <div class="flex gap-2 justify-content-end">
                            <p-button *ngIf="allowDelete" (click)="delete(template)" [rounded]="true" [text]="false"
                                severity="danger"><i class="pi pi-trash"></i></p-button>
                            <p-button *ngIf="allowWrite" (click)="edit(template)" [rounded]="true" [text]="false"><i
                                    class="pi pi-pencil"></i></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </p-tabPanel>
    <p-tabPanel header="Comunicaciones" >
        <p-table styleClass="mt-4" #grid [value]="templatesCaseLogs" [lazy]="true" (onLazyLoad)="loadDataCaseLogs($event)" [loading]="loading"
            [paginator]="true" [rows]="25" [totalRecords]="totalRecordsCaseLogs" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                    <!--<th pSortableColumn="templateType">Tipo <p-sortIcon field="templateType"></p-sortIcon></th>-->
                    <th pSortableColumn="content">Contenido <p-sortIcon field="content"></p-sortIcon></th>
                    <th width="100"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-template let-columns="columns">
                <tr (dblclick)="edit(template)">
                    <td>{{template.name}}</td>
                    <!--<td>{{templatesService.getTemplateTypeLabel(template.templateType)}}</td>-->
                    <td [innerHTML]="template.content"></td>
                    <td>
                        <div class="flex gap-2 justify-content-end">
                            <p-button *ngIf="allowDelete" (click)="delete(template)" [rounded]="true" [text]="false"
                                severity="danger"><i class="pi pi-trash"></i></p-button>
                            <p-button *ngIf="allowWrite" (click)="edit(template)" [rounded]="true" [text]="false"><i
                                    class="pi pi-pencil"></i></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </p-tabPanel>
</p-tabView>

<p-confirmDialog></p-confirmDialog>